<ion-header class="extendido extendido-min" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Buscar' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content padding *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content padding *ngIf="loaded">
  <div class="gradient-extendido"></div>

  <ion-grid class="list-search">
    <div class="gradient-extendido-div">
      <div class="div-top">
        <ion-note slot="start">
          <i class="fas fa-search div-icon"></i>
        </ion-note>

        <ion-label class="color-title"> {{'Buscar por Pessoa' | translate}} </ion-label>
      </div>
    </div>

    <ion-row size="12" (click)="buscarGrupo(1);">
      <ion-col class="remove-border">
        <ion-item>
          <ion-note slot="start">
            <i class="fas fa-users icon-list"></i>
          </ion-note>

          <ion-label class="item-content">
            <h3 class="item-title">
              <span class="bold-2"> {{'Buscar por ' | translate}} {{'grupo' | nomenclatura | async}} </span>
            </h3>
          </ion-label>

          <ion-note slot="end">
            <i class="fa-solid fa-chevron-right icon-list"></i>
          </ion-note>
        </ion-item>
      </ion-col>
    </ion-row>

    <ion-row size="12" (click)="buscarGrupo(2);">
      <ion-col class="remove-border">
        <ion-item>
          <ion-note slot="start">
            <i class="fa-solid fa-church icon-list"></i>
          </ion-note>

          <ion-label class="item-content">
            <h3 class="item-title">
              <span class="bold-2"> {{'Buscar por ' | translate}} {{'ministerio' | nomenclatura | async}} </span>
            </h3>
          </ion-label>

          <ion-note slot="end">
            <i class="fa-solid fa-chevron-right icon-list"></i>
          </ion-note>
        </ion-item>
      </ion-col>
    </ion-row>

    <ion-row size="12" (click)="buscarPessoa();">
      <ion-col class="remove-border">
        <ion-item>
          <ion-note slot="start">
            <i class="fas fa-user-friends icon-list"></i>
          </ion-note>

          <ion-label class="item-content">
            <h3 class="item-title">
              <span class="bold-2"> {{'Buscar por Pessoa' | translate}} </span>
            </h3>
          </ion-label>

          <ion-note slot="end">
            <i class="fa-solid fa-chevron-right icon-list"></i>
          </ion-note>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-grid *ngIf="idEscala">
    <div class="gradient-extendido-div">
      <div class="div-top">
        <ion-note slot="start">
          <i class="fas fa-cogs div-icon"></i>
        </ion-note>

        <ion-label class="color-title"> {{'Funções sem responsável' | translate}} </ion-label>
      </div>
    </div>

    <ion-row size="12">
      <ion-col>
        <ion-searchbar
          show-cancel-button="never"
          placeholder="{{'Buscar' | translate}}"
          [(ngModel)]="filtro"
          (ionInput)="onInput()"
          class="custom"
          [debounce]="500"
        >
        </ion-searchbar>
      </ion-col>
    </ion-row>

    <ion-row size="12" *ngFor="let funcao of funcoesList">
      <ion-col (click)="selecionarFuncao(funcao)">
        <ion-item>
          <ion-note slot="start">
            <i class="fas fa-users icon-list color-icon"></i>
          </ion-note>

          <ion-label>
            <h3>{{funcao.funcao}} ({{funcao.qtdDisponivel}}/{{funcao.qtd}})</h3>
          </ion-label>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-infinite-scroll (ionInfinite)="loadFuncoes($event)" *ngIf="pagination.currentPage < pagination.pageCount">
      <ion-infinite-scroll-content loadingText="{{'Carregando' | translate}}..."> </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </ion-grid>
</ion-content>
